module.exports = __webpack_public_path__ + "static/media/fluoro-visible.9ca0d867.svg";